import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const Bath = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83342 7.49996C6.75389 7.49996 7.50008 6.75377 7.50008 5.83329C7.50008 4.91282 6.75389 4.16663 5.83342 4.16663C4.91294 4.16663 4.16675 4.91282 4.16675 5.83329C4.16675 6.75377 4.91294 7.49996 5.83342 7.49996Z"
        fill="#222222"
      />
      <path
        d="M16.6667 10.8333V4.02496C16.6667 2.72496 15.6084 1.66663 14.3084 1.66663C13.6834 1.66663 13.0834 1.91663 12.6417 2.35829L11.6001 3.39996C11.4667 3.35829 11.3251 3.33329 11.1751 3.33329C10.8417 3.33329 10.5334 3.43329 10.2751 3.59996L12.5751 5.89996C12.7417 5.64163 12.8417 5.33329 12.8417 4.99996C12.8417 4.84996 12.8167 4.71663 12.7834 4.57496L13.8251 3.53329C13.9501 3.40829 14.1251 3.33329 14.3084 3.33329C14.6917 3.33329 15.0001 3.64163 15.0001 4.02496V10.8333H9.29175C9.04175 10.6583 8.81675 10.4583 8.60842 10.2333L7.44175 8.94163C7.28342 8.76663 7.08341 8.62496 6.86675 8.52496C6.60841 8.39996 6.32508 8.33329 6.03341 8.33329C5.00008 8.34163 4.16675 9.17496 4.16675 10.2083V10.8333H1.66675V15.8333C1.66675 16.75 2.41675 17.5 3.33341 17.5C3.33341 17.9583 3.70841 18.3333 4.16675 18.3333H15.8334C16.2917 18.3333 16.6667 17.9583 16.6667 17.5C17.5834 17.5 18.3334 16.75 18.3334 15.8333V10.8333H16.6667ZM16.6667 15.8333H3.33341V12.5H16.6667V15.8333Z"
        fill="#222222"
      />
    </svg>
  </SVGIcon>
)

export default Bath
